export interface User {
    email: string;
    password: string;
}

export interface CurrentUser {
    id: string,
    username: string,
    firstName: string,
    lastName: string,
    languageCode: string,
    isRegularUser: boolean,
    roles: string[]
}

export interface JwtConfigs {
    jwtExpireSeconds: number,
    jwtInvalidSeconds: number,
    jwtLogoutWarningSeconds: number,
}

export interface AuthenticationState {
    currentUser: CurrentUser,
    token: string,
    tokenValidTo: Date | null,
    jwtConfigs: JwtConfigs,
    autoLogout: boolean
}

export enum RoleEnum {
    // actions
    Any = "Any",
    ContractsRole = "ContractsRole",
    InstancesRole = "InstancesRole",
    RestrictedAccessRole = "RestrictedAccessRole"
}
